/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Vocabulary } from "../../Utils/Vocabulary";
import {
  Button,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { toast } from "react-toastify";
import { Delete, Edit } from "@mui/icons-material";
import { LocalUrlEnum, UrlEnum } from "../../Utils/Utils";
import { getData } from "../../Services/getData";
import theme from "../../Theme/Theme";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import AddOrderStatusModal from "./AddOrderStatusModal";
import DeleteOrderStatus from "./DeleteOrderStatus";
import { deleteData } from "../../Services/deleteData";
import { postData } from "../../Services/postData";
import { useLocation, useNavigate } from "react-router-dom";
import { breadCrumbsEnum } from "../../Utils/Constants";

export default function OrderStatus() {
  const navigate = useNavigate();
  const location = useLocation();
  const notifyError = (message: string) => toast.error(message);
  const notifySuccess = (message: string) => toast.success(message);
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const [openAddOrderStatusModal, setOpenAddOrderStatusModal] = useState(false);
  const [showDeleteOrderStatusModal, setShowDeleteOrderStatusModal] =
    useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState<any>(null);
  const [state, setState] = useState<any>({
    orderStatusPerPage: [],
    orderStatusNumber: 0,
    page: 0,
    perPage: 10,
    search: null,
    order: "asc",
    filter: null,
    preview: false,
    selectedRequest: {},
    loading: false,
  });
  const userName = localStorage.getItem("userName")
    ? localStorage.getItem("userName")
    : "";

  useEffect(() => {
    breadCrumbsContext.setBreadCrumbs([`${breadCrumbsEnum.orderStatus}`]);
    const search = location.search.split("?");
    const newState = Object.assign({}, state) as any;
    search.forEach((value) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "page") newState[values[0]] = +values[1] - 1;
        else newState[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
      }
    });
    getOrderStatus(newState.page, newState.perPage, newState.search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  /**
   *
   */
  function getOrderStatus(
    page: number,
    perPage: number,
    search?: string | null
  ) {
    setLoading(true);
    let url = `${UrlEnum.orderStatus}/${page}/${perPage}`;
    if (search) {
      url = `${UrlEnum.orderStatus}/${page}/${perPage}/${search}`;
    }
    getData(url)
      .then((res) => {
        setState({
          ...state,
          orderStatusPerPage: res.data.orderStatus,
          orderStatusNumber: res.data.orderStatusNumber,
          page: page,
          perPage: perPage,
          search: search || null,
        });
        setLoading(false);
      })
      .catch((err) => {
        notifyError(Vocabulary.getError);
        setLoading(false);
      });
  }

  /**
   *
   */
  const handleChangeOrderStatusModalValue = async () => {
    setOpenAddOrderStatusModal(!openAddOrderStatusModal);
    setSelectedRow(null);
  };
  /**
   *
   * @param {*} row
   */
  const onDeleteOrderStatus = async (row: any) => {
    setDeleteId(row);
    setShowDeleteOrderStatusModal(true);
  };

  /**
   *
   * @param {*} row
   */
  const onEditOrderStatus = async (row: any) => {
    setSelectedRow(row);
    setOpenAddOrderStatusModal(true);
  };

  /**
   *
   * @param rowIndex
   */
  function sortDown(rowIndex: number) {
    setLoading(true);
    const body = {
      status1: state.orderStatusPerPage[rowIndex],
      status2: state.orderStatusPerPage[rowIndex + 1],
      userName: userName,
    };
    postData(`${UrlEnum.orderStatus}/update/sortNumber`, body)
      .then((res) => {
        setLoading(false);
        getOrderStatus(state.page, state.perPage, state.search);
      })
      .catch((err) => {
        notifyError(Vocabulary.getError);
        setLoading(false);
      });
  }

  /**
   *
   * @param rowIndex
   */
  function sortUp(rowIndex: number) {
    setLoading(true);

    const body = {
      status1: state.orderStatusPerPage[rowIndex],
      status2: state.orderStatusPerPage[rowIndex - 1],
      userName: userName,
    };
    postData(`${UrlEnum.orderStatus}/update/sortNumber`, body)
      .then((res) => {
        setLoading(false);
        getOrderStatus(state.page, state.perPage, state.search);
      })
      .catch((err) => {
        notifyError(Vocabulary.getError);
        setLoading(false);
      });
  }
  /**
   *
   */
  function handleDelete() {
    setLoading(true);
    deleteData(
      `${UrlEnum.orderStatus}/${deleteId._id}/${deleteId.sortNumber}/${userName}`
    )
      .then(async (res) => {
        getOrderStatus(state.page, state.perPage, state.search);
        setLoading(false);
        setShowDeleteOrderStatusModal(false);
        notifySuccess(Vocabulary.deleteSuccess);
      })
      .catch((err) => {
        setLoading(false);
        setShowDeleteOrderStatusModal(false);
        notifyError(Vocabulary.deleteError);
      });
  }

  const requestHeaders = [
    {
      label: "Ordinea statusurilor".toUpperCase(),
      name: "",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
          width: 25,
        }),
        filter: false,
        sort: false,
        selectableRowsHeader: true,
        empty: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "centers",
                justifyContent: "space-between",
              }}
            >
              <Button
                disabled={
                  rowIndex === state.orderStatusPerPage.length - 1
                    ? true
                    : false
                }
                color="inherit"
                style={{ padding: 0 }}
              >
                <KeyboardArrowDownIcon
                  style={{ cursor: "pointer" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    sortDown(rowIndex);
                  }}
                />
              </Button>
              <Button
                disabled={rowIndex === 0 ? true : false}
                color="inherit"
                style={{ padding: 0 }}
              >
                <KeyboardArrowUpIcon
                  style={{ cursor: "pointer" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    sortUp(rowIndex);
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
    {
      label: Vocabulary.name.toUpperCase(),
      name: "name",
      options: { sort: false },
    },
    {
      label: Vocabulary.statusType.toUpperCase(),
      name: "type",
      options: {
        sort: false,
        customBodyRender: (value: any) =>
          value === "repair"
            ? Vocabulary.statusTypeRepair
            : Vocabulary.statusTypeBuy,
      },
    },
    {
      label: Vocabulary.options.toUpperCase(),
      name: "optiuni",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          return (
            <div
              style={{
                marginTop: -10,
                marginBottom: -10,
                color: "white !important",
              }}
            >
              <ToggleButtonGroup exclusive aria-label="text alignment">
                <Tooltip title={Vocabulary.edit}>
                  <ToggleButton
                    onClick={() => {
                      onEditOrderStatus(state.orderStatusPerPage[rowIndex]);
                    }}
                    value="center"
                    aria-label="centered"
                  >
                    <Edit />
                  </ToggleButton>
                </Tooltip>
                <Tooltip title={Vocabulary.delete}>
                  <ToggleButton
                    onClick={(event) => {
                      event.stopPropagation();
                      onDeleteOrderStatus(state.orderStatusPerPage[rowIndex]);
                    }}
                    value="center"
                    aria-label="centered"
                  >
                    <Delete />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </div>
          );
        },
      },
    },
  ];

  /**
   *
   * @returns
   */
  function getTableOptions() {
    const responsive: "standard" | "vertical" | "simple" | undefined =
      "standard";
    return {
      selectableRows: "none" as any,
      viewColumns: false as any,
      responsive: responsive,
      rowsPerPageOptions: [10, 20, 50, 100],
      confirmFilters: true,
      filter: false,
      print: false,
      download: false,
      textLabels: {
        body: {
          noMatch: Vocabulary.noResultsFound,
        },
      },
      rowsPerPage: state.perPage,
      count: state.orderStatusNumber,
      page: state.page,
      search: true,
      serverSide: true,
      sort: true,
      setRowProps: (row: any, dataIndex: any, rowIndex: any) => {
        return {
          style: {
            backgroundColor: state.orderStatusPerPage[rowIndex].color,
            cursor: "pointer",
          },
        };
      },
      onChangePage: (page: any) => {
        navigate(
          `${LocalUrlEnum.orderStatus}?page=${page + 1}?perPage=${
            state.perPage
          }`
        );
        window.scrollTo(0, 0);
      },
      onChangeRowsPerPage: (numberOfRows: number) => {
        navigate(
          `${LocalUrlEnum.orderStatus}?page=${1}?perPage=${numberOfRows}`
        );
        window.scrollTo(0, 0);
      },
      onSearchChange: async (search: string | null) => {
        if (search) {
          navigate(
            `${LocalUrlEnum.orderStatus}?page=${state.page + 1}?perPage=${
              state.perPage
            }?search=${search}`
          );
        } else {
          setState({ ...state, search: null });
          navigate(
            `${LocalUrlEnum.orderStatus}?page=${state.page + 1}?perPage=${
              state.perPage
            }`
          );
        }
      },
      onSearchClose: async () => {
        setState({ ...state, search: null });
        navigate(
          `${LocalUrlEnum.orderStatus}?page=${state.page + 1}?perPage=${
            state.perPage
          }`
        );
      },
    };
  }

  return (
    <>
      <div style={{ textAlign: "end", marginBottom: 10 }}>
        <Button
          variant="contained"
          size="large"
          style={{
            color: theme.palette.whiteColor?.main,
            backgroundColor: theme.palette.dashboard?.main,
          }}
          onClick={handleChangeOrderStatusModalValue}
        >
          {Vocabulary.newOrderStatus}
        </Button>
      </div>
      <MUIDataTable
        title={Vocabulary.orderStatus}
        data={state.orderStatusPerPage}
        columns={requestHeaders}
        options={getTableOptions()}
      />
      <AddOrderStatusModal
        openAddOrderStatusModal={openAddOrderStatusModal}
        handleChangeOrderStatusModalValue={handleChangeOrderStatusModalValue}
        selectedRow={selectedRow}
        sortNumber={state.orderStatusNumber}
        getOrderStatus={() =>
          getOrderStatus(state.page, state.perPage, state.search)
        }
      />
      <DeleteOrderStatus
        openDeleteModal={showDeleteOrderStatusModal}
        setOpenDeleteModal={setShowDeleteOrderStatusModal}
        handleDelete={handleDelete}
      />
      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
